import React, { useState, useEffect } from "react";
import AddnExport from "./sub-components/Add-Export";
import DataTable from "react-data-table-component";
import { ActivePill, InactivePill } from "./sub-components/StatusPill";
import { useNavigate } from "react-router-dom";
import Search from "./sub-components/Search";
import TableActions from "./sub-components/TableActions";
import { StockService } from "../../../../services/StockService";
import moment from "moment";
const TeamMembers = () => {
  const navigate = useNavigate();
  const speciesColumns = [
    {
      name: "Name",
      selector: (row) => row.teamName,
    },
    {
      name: "Description",
      selector: (row) => row.description,
    },
    // {
    //   name: "Team Members",
    //   selector: (row) => {
        
    //     return (
    //       <div className="flex -space-x-1">
    //         {row.teamMembers.slice(0,4).map((member) => (
    //           <div className="relative group">
    //           <span className="flex items-center justify-center font-bold text-white bg-gray-400 rounded-full group-hover:bg-gray-500 h-7 w-7 ring-2 ring-white">
    //             {member.name[0]}
    //           </span>
    //           </div>
    //         ))}
    //       </div>
    //     );
    //   },
    // },
    {
      name: "Active",
      selector: (row) =>
        row.isActive ? (
          <ActivePill>Active</ActivePill>
        ) : (
          <InactivePill>Inactive</InactivePill>
        ),
    },
    {
      name: "Date",
      selector: (row) => moment(row.dateCreated).format('yyyy-MM-DD'),
    },
    {
      name: "Actions",
      selector: (row) => (
        <div>
          <TableActions
            viewAction={() => navigate(`${row.teamId}`)}
            deleteAction={() =>
              window.confirm(`Are you sure you want to delete this species`)
            }
          />
        </div>
      ),
    },
  ];

  const [pending, setPending] = useState(true);
  const [teams,setTeams] = useState([])
 
  useEffect(() => {
  handleTeams();
// eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

   

  const handleTeams = () => {
    StockService.GetTeams().then((res) => {
      
      setTeams(...teams, res);
      setPending(false);
      // console.log(concessions)
      
    });
  };

const [search] = useState("");
  return (
    <div className="w-full">
      <AddnExport />
      <Search />
      <DataTable
        className="w-full rounded rounded-lg"
        columns={speciesColumns}
    
        data={teams.filter((item) => {
          if (search === "") {
            return item;
          } else return(
            item.description.toLowerCase().includes(search.toLowerCase())
          )
        })}
      progressPending={pending}
        pagination
      />
    </div>
  );
};

export default TeamMembers;
